// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var Relude_Set = require("relude/src/Relude_Set.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var GraphQL_PPX = require("@reasonml-community/graphql-ppx/bucklescript/GraphQL_PPX.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var GraphqlHelpers = require("../../../shared/src/GraphqlHelpers.bs.js");
var CommonTypes_Shift = require("../../../shared/src/types/CommonTypes_Shift.bs.js");
var CommonTypes_Rating = require("../../../shared/src/types/CommonTypes_Rating.bs.js");
var CommonTypes_User_Name = require("../../../shared/src/types/CommonTypes_User_Name.bs.js");
var CommonTypes_Worker_Id = require("../../../shared/src/types/worker/CommonTypes_Worker_Id.bs.js");
var CommonTypes_PhoneNumber = require("../../../shared/src/types/CommonTypes_PhoneNumber.bs.js");
var CommonTypes_WorkerShift = require("../../../shared/src/types/CommonTypes_WorkerShift.bs.js");
var CommonTypes_ProfilePicture = require("../../../shared/src/types/CommonTypes_ProfilePicture.bs.js");
var CommonTypes_WorkerShift_TipAmount = require("../../../shared/src/types/CommonTypes_WorkerShift_TipAmount.bs.js");

var Raw = {};

var query = "fragment WebTypes_WorkerShift on WorkerShift   {\n...CommonTypes_WorkerShift_TipAmount   \nclockedInAt  \nclockedOutAt  \ncomment  \nid  \nrating: ratingFromBusiness  \nshiftId  \nworkerId  \nworker  {\nuser: usersByProfileableId(first: 1, filter: {profileableType: {equalTo: \"Worker\"}})  {\nnodes  {\n...CommonTypes_User_Name   \nphoneNumber  \nid  \nprofilePictures(filter: {rejectedAt: {isNull: true}, approvedAt: {isNull: false}}, orderBy: [APPROVED_AT_DESC], first: 1)  {\nnodes  {\n...CommonTypes_ProfilePicture   \n}\n\n}\n\n}\n\n}\n\n}\n\n}\n" + CommonTypes_ProfilePicture.query + CommonTypes_User_Name.query + CommonTypes_WorkerShift_TipAmount.query;

function parse(value) {
  var value$1 = value["clockedInAt"];
  var value$2 = value["clockedOutAt"];
  var value$3 = value["comment"];
  var value$4 = value["rating"];
  var value$5 = value["worker"];
  var value$6 = value$5.user;
  var value$7 = value$6.nodes;
  return {
          commonTypes_WorkerShift_TipAmount: CommonTypes_WorkerShift_TipAmount.verifyArgsAndParse("CommonTypes_WorkerShift_TipAmount", value),
          clockedInAt: !(value$1 == null) ? Caml_option.some(GraphqlHelpers.Datetime.parse(value$1)) : undefined,
          clockedOutAt: !(value$2 == null) ? Caml_option.some(GraphqlHelpers.Datetime.parse(value$2)) : undefined,
          comment: !(value$3 == null) ? value$3 : undefined,
          id: Curry._1(CommonTypes_WorkerShift.Id.GraphQL_API.parse, value["id"]),
          rating: !(value$4 == null) ? value$4 : undefined,
          shiftId: Curry._1(CommonTypes_Shift.Id.GraphQL_API.parse, value["shiftId"]),
          workerId: CommonTypes_Worker_Id.GraphQL_API.parse(value["workerId"]),
          worker: {
            user: {
              nodes: value$7.map(function (value) {
                    if (value == null) {
                      return ;
                    }
                    var value$1 = value["profilePictures"];
                    var value$2 = value$1.nodes;
                    return {
                            commonTypes_User_Name: CommonTypes_User_Name.verifyArgsAndParse("CommonTypes_User_Name", value),
                            phoneNumber: CommonTypes_PhoneNumber.GraphQL_API_FromString.parse(value["phoneNumber"]),
                            id: value["id"],
                            profilePictures: {
                              nodes: value$2.map(function (value) {
                                    if (!(value == null)) {
                                      return CommonTypes_ProfilePicture.verifyArgsAndParse("CommonTypes_ProfilePicture", value);
                                    }
                                    
                                  })
                            }
                          };
                  })
            }
          }
        };
}

function serialize(value) {
  var value$1 = value.worker;
  var value$2 = value$1.user;
  var value$3 = value$2.nodes;
  var nodes = value$3.map(function (value) {
        if (value === undefined) {
          return null;
        }
        var value$1 = value.profilePictures;
        var value$2 = value$1.nodes;
        var nodes = value$2.map(function (value) {
              if (value !== undefined) {
                return CommonTypes_ProfilePicture.serialize(value);
              } else {
                return null;
              }
            });
        var profilePictures = {
          nodes: nodes
        };
        var value$3 = value.id;
        var value$4 = value.phoneNumber;
        var value$5 = CommonTypes_PhoneNumber.GraphQL_API_FromString.serialize(value$4);
        return [CommonTypes_User_Name.serialize(value.commonTypes_User_Name)].reduce(GraphQL_PPX.deepMerge, {
                    phoneNumber: value$5,
                    id: value$3,
                    profilePictures: profilePictures
                  });
      });
  var user = {
    nodes: nodes
  };
  var worker = {
    user: user
  };
  var value$4 = value.workerId;
  var value$5 = Curry._1(CommonTypes_Worker_Id.GraphQL_API.serialize, value$4);
  var value$6 = value.shiftId;
  var value$7 = Curry._1(CommonTypes_Shift.Id.GraphQL_API.serialize, value$6);
  var value$8 = value.rating;
  var rating = value$8 !== undefined ? value$8 : null;
  var value$9 = value.id;
  var value$10 = Curry._1(CommonTypes_WorkerShift.Id.GraphQL_API.serialize, value$9);
  var value$11 = value.comment;
  var comment = value$11 !== undefined ? value$11 : null;
  var value$12 = value.clockedOutAt;
  var clockedOutAt = value$12 !== undefined ? Curry._1(GraphqlHelpers.Datetime.serialize, Caml_option.valFromOption(value$12)) : null;
  var value$13 = value.clockedInAt;
  var clockedInAt = value$13 !== undefined ? Curry._1(GraphqlHelpers.Datetime.serialize, Caml_option.valFromOption(value$13)) : null;
  return [CommonTypes_WorkerShift_TipAmount.serialize(value.commonTypes_WorkerShift_TipAmount)].reduce(GraphQL_PPX.deepMerge, {
              clockedInAt: clockedInAt,
              clockedOutAt: clockedOutAt,
              comment: comment,
              id: value$10,
              rating: rating,
              shiftId: value$7,
              workerId: value$5,
              worker: worker
            });
}

function verifyArgsAndParse(_WebTypes_WorkerShift, value) {
  return parse(value);
}

function verifyName(param) {
  
}

function tToR(param) {
  var match = param.worker.user.nodes;
  if (match.length !== 1) {
    return ;
  }
  var match$1 = match[0];
  if (match$1 !== undefined) {
    return Relude_Option.pure({
                clockedInAt: param.clockedInAt,
                clockedOutAt: param.clockedOutAt,
                comment: param.comment,
                id: param.id,
                phoneNumber: match$1.phoneNumber,
                rating: Curry._2(Relude_Option.flatMap, CommonTypes_Rating.fromInt, param.rating),
                shiftId: param.shiftId,
                tipAmount: CommonTypes_WorkerShift_TipAmount.tToR(param.commonTypes_WorkerShift_TipAmount),
                workerId: param.workerId,
                workerName: match$1.commonTypes_User_Name,
                workerProfilePicture: Curry._1(Relude_Option.flatten, Relude_Array.head(match$1.profilePictures.nodes))
              });
  }
  
}

function compare(param, param$1) {
  return Curry._2(CommonTypes_WorkerShift.Id.compare, param.id, param$1.id);
}

function eq(param, param$1) {
  return Curry._2(CommonTypes_WorkerShift.Id.eq, param.id, param$1.id);
}

var Ord = {
  eq: eq,
  compare: compare
};

var $$Set = Relude_Set.WithOrd(Ord);

exports.Raw = Raw;
exports.query = query;
exports.parse = parse;
exports.serialize = serialize;
exports.verifyArgsAndParse = verifyArgsAndParse;
exports.verifyName = verifyName;
exports.tToR = tToR;
exports.compare = compare;
exports.eq = eq;
exports.Ord = Ord;
exports.$$Set = $$Set;
/* Set Not a pure module */
